var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVerificationIconOk(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "19px",
    height: "14px",
    viewBox: "0 0 19 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "mdpi/\uE886") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Self-check-Cargill",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Site-level-entrance-Copy",
    transform: "translate(-1077.000000, -654.000000)",
    fill: "#68AC58",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Past-entries",
    transform: "translate(77.000000, 579.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "verify",
    transform: "translate(997.000000, 22.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\uE886",
    points: "8.81037567 64.0697674 19.8550984 53 21.332737 54.4776386 8.81037567 67 3 61.1896243 4.45259392 59.7119857"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationIconOk);
export default __webpack_public_path__ + "static/media/verification_icon_ok.4769f22864ce42f104079ef01995b438.svg";
export { ForwardRef as ReactComponent };